import { ptBR } from '@mui/material/locale';
import { createTheme } from '@mui/material';

const ProduttivoMuiThemeV1 = createTheme(
  {
    palette: {
      primary: {
        main: '#01a32d',
      },
      success: {
        main: '#01a32d',
      },
      warning: {
        main: '#EA620E',
      },
      info: {
        main: '#1D64F3',
      },
      error: {
        main: '#E41324',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            'text-transform': 'none',
            '&.MuiButton-outlinedSuccess': {
              'border-color': '#D2D2D2',
            },
          },
          sizeMedium: {
            fontSize: '1rem',
            minWidth: '80px',
            maxWidth: '200px'
          },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          toolbar: {
            alignItems: 'baseline',
          },
        },
      },
    },
  },
  ptBR
);

export default ProduttivoMuiThemeV1;